import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { cashService } from '../../services/cashService';

export const useGetRepaymentDetailByDeadline = deadline => {
  return useQuery({
    queryKey: [QUERY_KEYS.cash.repayment_detail_deadline, deadline],
    refetchOnWindowFocus: false,
    enabled: false,
    queryFn: () =>
      cashService.repaymentDetail(deadline).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return null;
      }),
  });
};
